import { app } from '../../../../bootstrap/core';
import { radioAccordionSectionComponent } from './radioAccordionSection.component';

app.component('radioAccordionSection', radioAccordionSectionComponent);
